import {PayoutState, ClosedAccount, PayoutReportState} from '../reducers/payout';

export const selectPayout = (state): PayoutState => state.get('payout').toJS();

export const selectClosedAccount = (state): ClosedAccount =>
    state.getIn(['payout', 'closedAccount']).toJS();

export const selectPayoutReport = (state): PayoutReportState =>
    state.getIn(['payout', 'payoutReport']).toJS();
